import React, { useState } from "react";
import axios from 'axios';
import Navbar from "@/pages/Navbar/Navbar";

export default function FormularioCliente() {
  const [form, setForm] = useState({
    nome: "",
    telefone: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cidade: "",
  });

  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "telefone") {
      const numbers = value.replace(/\D/g, "");
      formattedValue = numbers
        .replace(/^(\d{2})(\d)/g, "($1)$2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .slice(0, 14);
    } else {
      formattedValue = value.toUpperCase();
    }

    setForm({ ...form, [name]: formattedValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro("");
    setSucesso(false);
  
    try {
      const response = await axios.post("/api/public/api/agendamentos", form);
  
      if (response.data.success) {
        setSucesso(true);
        setForm({
          nome: "",
          telefone: "",
          rua: "",
          numero: "",
          bairro: "",
          complemento: "",
          cidade: "",
        });
      }
    } catch (err) {
      setErro("❌ Erro ao enviar o formulário. Tente novamente.");
    } finally {
      setEnviando(false);
    }
  };
  
  

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white shadow-2xl p-8 rounded-xl border border-yellow-200/50">
          <h2 className="text-3xl font-bold text-yellow-600 mb-6 text-center">
            ✍️ Formulário de Solicitação
          </h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input name="nome" value={form.nome} onChange={handleChange} placeholder="NOME" required className="input" />
            <input name="telefone" value={form.telefone} onChange={handleChange} placeholder="TELEFONE" required className="input" />
            <input name="rua" value={form.rua} onChange={handleChange} placeholder="RUA" required className="input" />
            <input name="numero" value={form.numero} onChange={handleChange} placeholder="NÚMERO" required className="input" />
            <input name="bairro" value={form.bairro} onChange={handleChange} placeholder="BAIRRO" required className="input" />
            <input name="complemento" value={form.complemento} onChange={handleChange} placeholder="COMPLEMENTO" className="input" />
            <input name="cidade" value={form.cidade} onChange={handleChange} placeholder="CIDADE" required className="input" />
            <div className="md:col-span-2 text-center mt-4">
              <button type="submit" disabled={enviando} className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-xl transition">
                {enviando ? "Enviando..." : "Enviar Solicitação"}
              </button>
            </div>
          </form>

          {sucesso && <p className="mt-4 text-green-600 text-center font-semibold">✅ Solicitação enviada com sucesso!</p>}
          {erro && <p className="mt-4 text-red-600 text-center font-semibold">{erro}</p>}
        </div>
      </div>
    </>
  );
}
